import { useState } from "react";
import API_ROUTES from "./apiRoutes"; 

export const useForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const sendRecoveryEmail = async ({ email }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    if (!email) {
      setError("Por favor, insira seu email.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(API_ROUTES.FORGOT_PASSWORD.default(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error("Erro ao enviar email de recuperação.");
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message || "Erro desconhecido.");
    } finally {
      setLoading(false);
    }
  };

  return { sendRecoveryEmail, success, loading, error };
};
